import { FormColorPicker } from 'app/pages/video/videoDetails/main/videoAnnotations/components/FormColorPicker';
import { useFormikContext } from 'formik';
import { Dropdown } from 'lib/components';

import { Gap } from 'lib/components/styles/layout';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import { Label, Section, SectionTitle, PreviewBtnText } from '../index.styled';
import {
  boxShadowOptions,
  buttonBorderOptions,
  buttonBorderRadiusOptions,
} from './const';
import { SalesPagesValues } from './types';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

export const SalesPagesCTAForm = () => {
  const { t } = useTranslation();
  const { initialValues, values, setFieldValue } =
    useFormikContext<SalesPagesValues>();

  const ctaBtnStyles = css`
    max-height: 40px;
    width: 130px;
    height: 40px;
    cursor: pointer;
    background: ${values.ctaButtonBgColor};
    color: ${values.ctaButtonTextColor};
    border-color: ${values.ctaButtonBorderColor};
    border-radius: ${values.ctaButtonBorderRadius};
    box-shadow: ${values.ctaButtonShadow};
    border-width: ${values.ctaButtonBorderThickness};

    &:hover {
      background: ${values.ctaButtonBgColorHover};
      color: ${values.ctaButtonTextColorHover};
      border-color: ${values.ctaButtonBorderColorHover};
    }
  `;

  const ButtonPreview = styled.button`
    ${ctaBtnStyles}
  `;

  return (
    <Section>
      <SectionTitle>{t('CTA')}</SectionTitle>
      <Gap>
        <FormColorPicker
          label={t('Button Background Color')}
          name='ctaButtonBgColor'
          menuPlacement='bottom'
          defaultColor={initialValues?.ctaButtonBgColor || '#FFF'}
          isClearable={true}
        />
        <FormColorPicker
          label={t('Button Text Color')}
          name='ctaButtonTextColor'
          menuPlacement='bottom'
          defaultColor={initialValues?.ctaButtonTextColor || '#FFF'}
          isClearable={true}
        />
        <FormColorPicker
          label={t('Button Border Color')}
          name='ctaButtonBorderColor'
          menuPlacement='bottom'
          defaultColor={initialValues?.ctaButtonBorderColor || '#FFF'}
          isClearable={true}
        />
        <FormColorPicker
          label={t('Button Background Color Hover')}
          name='ctaButtonBgColorHover'
          menuPlacement='bottom'
          defaultColor={initialValues?.ctaButtonBgColorHover || '#FFF'}
          isClearable={true}
        />
        <FormColorPicker
          label={t('Button Text Color Hover')}
          name='ctaButtonTextColorHover'
          menuPlacement='bottom'
          defaultColor={initialValues?.ctaButtonTextColorHover || '#FFF'}
          isClearable={true}
        />
        <FormColorPicker
          label={t('Button Border Color Hover')}
          name='ctaButtonBorderColorHover'
          menuPlacement='bottom'
          defaultColor={initialValues?.ctaButtonBorderColorHover || '#FFF'}
          isClearable={true}
        />
        <Gap
          flexDirection='column'
          alignItems='flex-start'
          gap='4px'
          width='100%'
        >
          <Label>{t('Button Border Thickness')}</Label>
          <Dropdown
            options={buttonBorderOptions.map(option => {
              option.label = t(option.label);
              return option;
            })}
            value={buttonBorderOptions.find(option => {
              if (option.value === values.ctaButtonBorderThickness) {
                if (i18n.exists(option.label)) {
                  option.label = t(option.label);
                }
                return option;
              }
              return null;
            })}
            onChange={(option: { value: number }) => {
              setFieldValue('ctaButtonBorderThickness', option.value);
            }}
            extendStyles={{
              container: {
                width: '100%',
              },
              menu: {
                zIndex: 3,
              },
            }}
            creatable={false}
            name='ctaButtonBorderThickness'
            placeholder={t('Border Thickness')}
          />
        </Gap>

        <Gap
          flexDirection='column'
          alignItems='flex-start'
          gap='4px'
          width='100%'
        >
          <Label>{t('Button Border Radius')}</Label>
          <Dropdown
            options={buttonBorderRadiusOptions.map(option => {
              option.label = t(option.label);
              return option;
            })}
            value={buttonBorderRadiusOptions.find(option => {
              if (option.value === values.ctaButtonBorderRadius) {
                if (i18n.exists(option.label)) {
                  option.label = t(option.label);
                }
                return option;
              }
              return null;
            })}
            onChange={(option: { value: number }) => {
              setFieldValue('ctaButtonBorderRadius', option.value);
            }}
            extendStyles={{
              container: {
                width: '100%',
              },
              menu: {
                zIndex: 3,
              },
            }}
            creatable={false}
            name='ctaButtonBorderRadius'
            placeholder={t('Border Radius')}
          />
        </Gap>

        <Gap
          flexDirection='column'
          alignItems='flex-start'
          gap='4px'
          width='100%'
        >
          <Label>{t('Button Border Shadow')}</Label>
          <Dropdown
            options={boxShadowOptions.map(option => {
              option.label = t(option.label);
              return option;
            })}
            value={boxShadowOptions.find(option => {
              if (option.value === values.ctaButtonShadow) {
                if (i18n.exists(option.label)) {
                  option.label = t(option.label);
                }
                return option;
              }
              return null;
            })}
            onChange={(option: { value: number }) => {
              setFieldValue('ctaButtonShadow', option.value);
            }}
            extendStyles={{
              container: {
                width: '100%',
              },
              menu: {
                zIndex: 3,
              },
            }}
            creatable={false}
            name='ctaButtonShadow'
            placeholder={t('Border Shadow')}
          />
        </Gap>
      </Gap>
      <Gap alignItems='center' gap='4px' width='100%' justifyContent='flex-end'>
        <ButtonPreview type='button' onClick={() => null}>
          <PreviewBtnText>{t('Preview')}</PreviewBtnText>
        </ButtonPreview>
      </Gap>
    </Section>
  );
};
